import {
  Theme,
  TypographyVariant,
  WithTheme,
  cx,
  interpolateRhythmMargin,
} from '@mint/core';
import { FormControlProps } from './form-control-props';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { useFormControlClassNames } from '../shared';

/**
 * Input base class name root.
 */
const ROOT_CLASS_NAME = 'form-control';

/**
 * Component to use.
 */
const DEFAULT_COMPONENT = 'div';

/**
 * `FormControl` component implementation before styling.
 */
export const FormControlComponent = React.forwardRef<any, FormControlProps>(
  (props, ref): React.ReactElement => {
    const {
      children,
      className,
      component: Component = DEFAULT_COMPONENT,
      dense,
      disabled,
      error,
      focused,
      warning,
      ...rest
    } = props;

    const componentProps = {
      className: cx(
        ROOT_CLASS_NAME,
        useFormControlClassNames(ROOT_CLASS_NAME, props),
        className,
      ),
      ...rest,
      ref,
    };

    return <Component {...componentProps}>{children}</Component>;
  },
);

FormControlComponent.displayName = 'FormControl';

const pickTypographyVariant = (
  props: WithTheme<FormControlProps>,
): TypographyVariant => (props.dense ? 'dense' : 'control');

export const FormControl = styled(FormControlComponent)`
  ${interpolateRhythmMargin(pickTypographyVariant)}
`;

// FormControl.propTypes = {
//   component: PropTypes.elementType as any,
//   dense: PropTypes.bool,
//   disabled: PropTypes.bool,
//   error: PropTypes.bool,
//   focused: PropTypes.bool,
//   theme: PropTypes.instanceOf(Theme as any),
//   warning: PropTypes.bool,
// };
